import { createAction, props } from '@ngrx/store';

import { CropAndCropAid } from 'src/app/shared/models';

import { LegalRestriction } from '../legal-restriction.model';

export const getLegalRestriction = createAction(
  '[Legal restriction] Get legal restriction',
  props<{ cropAidId: number; cropId: number }>(),
);

export const getLegalRestrictions = createAction(
  '[Legal restriction] Get legal restrictions',
  props<{ cropAndCropAids: CropAndCropAid[] }>(),
);

export const setLegalRestriction = createAction(
  '[Legal restriction] Set legal restriction',
  props<{ legalRestriction: LegalRestriction }>(),
);

export const setLegalRestrictions = createAction(
  '[Legal restriction] Set legal restrictions',
  props<{ legalRestrictions: LegalRestriction[] }>(),
);
